// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2Q-K5","box":"WorkspacesBox_box__3e6RY","node":"WorkspacesBox_node__g0yul"};